<template>
    <div class="invitation-notification__container">
        <div v-if="invitation" class="alert alert-info">
            <p>
                {{ invitation.addedByUser.givenName }}  {{ invitation.addedByUser.familyName }}
                on kutsunut sinut buukkaa-bandi.fi- palveluun ja bändiin {{ invitation.band.bandName }}.
            </p>
        </div>
    </div>
</template>

<script>
    import ApiCall from '../modules/ApiCall';
    import Routes from '../modules/Routes';

    export default {
        model: {
            prop: 'email',
            event: 'change'
        },
        props: {
            invitationId: {
                type: String,
                default: null
            },
            invitationChecksum: {
                type: String,
                default: null
            }
        },
        mounted() {
            if (this.invitationId && this.invitationChecksum) {
                ApiCall.getCached(
                    Routes.generate('_public_api_get_invitation', { id: this.invitationId, hash: this.invitationChecksum }), true
                ).then((invitationData) => {
                    this.setInvitation(invitationData);
                }).catch((error) => {
                    this.setError(error);
                });
            }
        },
        data() {
            return {
                invitation: null
            };
        },
        methods: {
            setEmail(val) {
                this.$emit('set-email', val);
            },
            setError(response) {
                this.$emit('error-occured', response);
            },
            setInvitation(val) {
                this.invitation = val;
                this.setEmail(val.email);
                this.$emit('set-invitation', val);
            }
        }
    };
</script>
